import { useEffect, useState } from "react";
import styles from "../Components/ProductList.module.css";
import HotelsItem from "../Components/HotelsItem";
import Api from "../api/hotelApi";
const Hotels = () => {
  const [services, setServices] = useState([]);
  useEffect(()=>{
    Api.get(`hotels/`).then((response)=>{
      setServices(response.data); 
      console.log(response.data);     
    }).catch((error)=>{
      console.log(error);

    })
  }, []);
    return <>
        <div className={`col-sm-12 ${styles.mainContainer}`}>
        <div className="container-fluid">          
          <div className="row">
            {/* { services.map((item)=>(<HotelsItem key={item.id} item={item} />
            ))}        */}
          </div>
        </div>
      </div>
      </>
}
export default Hotels;